import { render, staticRenderFns } from "./impress.vue?vue&type=template&id=62738b34&scoped=true&"
import script from "./impress.vue?vue&type=script&lang=ts&"
export * from "./impress.vue?vue&type=script&lang=ts&"
import style0 from "./impress.vue?vue&type=style&index=0&id=62738b34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62738b34",
  null
  
)

export default component.exports